import React, { useEffect } from "react";
import "./Files.scss";
import {
  Word,
  Excel,
  Pdf,
  ImageBlank,
  JPG,
  Png,
  Ppt,
  checked,
  unChecked,
  deleteIcon,
  RenameFolderIcon,
  HideIcon,
  grayViewIcon,
} from "../../../assets/images";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import { childFolderType } from "../../../redux/fileManager/fileManagerTypes";

type AppProps = {
  type?: string;
  documentFile: any;
  showDeleteIcon: boolean;
  handleToggleViewMoreFiles?: () => void;
  toggleRenameFileModal?: () => void;
  handleSetViewMoreFileId?: (file_id: number | null | undefined) => void;
  showViewMoreFiles: boolean;
  viewMoreFileId?: number | null | undefined;
  handleSetFileRenameModalData?: (data: any) => void;
  isRenameFilePresent: boolean;
  multipleFileData?: any;
  setMultipleFileData?: any;
  filesData?: any;
  setFilesData?: any;
  uploadData?: any;
  removingFileData?: (data: string) => void;
  getImageDetails?: (url: ImageDataType) => void;
  handleUploadInvoiceFile?: (
    finalFileName: string,
    fileUrl: string,
    fileType: string
  ) => void;
  setShowViewMoreFiles?: React.Dispatch<React.SetStateAction<boolean>>;
  handleDeleteFileAndFolder?: (folderData: childFolderType) => void;
  isFileAndFolderDelete?: boolean;
  handleHideFileFolder?:(data:childFolderType)=>void;
  handleUnHideFileFolder?:(data:childFolderType)=>void;
  isHideAndShowFileFolderPresent?:boolean;
  isParrentHide?:number|null;
};

const Files = React.memo(
  ({
    type,
    isParrentHide,
    documentFile,
    showDeleteIcon,
    handleToggleViewMoreFiles,
    handleSetViewMoreFileId,
    showViewMoreFiles,
    viewMoreFileId,
    toggleRenameFileModal,
    isRenameFilePresent,
    handleSetFileRenameModalData,
    getImageDetails,
    handleUploadInvoiceFile,
    setMultipleFileData,
    filesData,
    setFilesData,
    removingFileData,
    handleDeleteFileAndFolder,
    isFileAndFolderDelete,
    handleHideFileFolder,
    handleUnHideFileFolder,
    isHideAndShowFileFolderPresent
  }: AppProps) => {

    useEffect(() => {
      const handleClickOutside = (event: any) => {
        if (event?.target?.innerHTML!="Rename File" && event?.target?.innerHTML!="Delete File" &&event?.target?.innerHTML!="Hide File"&&event?.target?.innerHTML!="Show File") {
          handleToggleViewMoreFiles && handleToggleViewMoreFiles();
          handleSetViewMoreFileId && handleSetViewMoreFileId(null);
        }
      };
    
      if (showViewMoreFiles) {
        document?.addEventListener("mousedown", handleClickOutside);
      }
    
      return () => {
        document?.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showViewMoreFiles]);
    
    const fileType = documentFile?.file_type;
    let fileNameSplited = documentFile?.file_name.split(".");
    const finalFileName =
    documentFile?.file_name?.length > 16
        ? `${documentFile?.file_name.slice(0, 16)}...${
            fileNameSplited[fileNameSplited?.length - 1]
          }`
        : documentFile?.file_name;

    let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
    let blobToken = process.env.REACT_APP_BLOB_TOEKN;

    const returnIcon = (fileType: string) => {
      switch (fileType) {
        case "pptx":
        case "ppt":
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        case "application/vnd.ms-powerpoint":
          return Ppt;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "application/msword":
          return Word;
        case "application/pdf":
          return Pdf;
        case "image/jpeg":
        case "image/jpg":
          return JPG;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "application/vnd.ms-excel":
        case "application/csv":
        case "text/x-csv":
        case "application/x-csv":
        case "text/csv":
          return Excel;
        case "image/png":
          return Png;
        default:
          return ImageBlank;
      }
    };
    const handleViewMoreClick = (
      e: any,
      document_id: number | null | undefined
    ) => {
      e.stopPropagation();
      handleToggleViewMoreFiles && handleToggleViewMoreFiles();
      handleSetViewMoreFileId && handleSetViewMoreFileId(document_id);
    };
    type ViewMoreAppProps = {
      fileData: any;
      handleToggleViewMoreFiles?: () => void;
      handleSetFileRenameModalData?: (data: any) => void;
      handleHideFileFolder?:(data:childFolderType)=>void;
      handleUnHideFileFolder?:(data:childFolderType)=>void;
      isHideAndShowFileFolderPresent?:boolean;
      isParrentHide?:number|null;

    };

    const ViewMoreBox = ({
      fileData,
      handleToggleViewMoreFiles,
      handleSetFileRenameModalData,
      handleHideFileFolder,
      handleUnHideFileFolder,
      isHideAndShowFileFolderPresent,
      isParrentHide
      
    }: ViewMoreAppProps) => {
      const handleRenameFileData = () => {
        handleToggleViewMoreFiles && handleToggleViewMoreFiles();
        toggleRenameFileModal && toggleRenameFileModal();
        handleSetFileRenameModalData && handleSetFileRenameModalData(fileData);
      };

      return (
        <div
          className="view-more-box d-flex align-items-center p-2"
          style={{
            width: "195px",
            height: "129px",
            border: "1px solid #bfcbe1",
          }}
        >
          <div style={{ fontSize: "14px", color: "#262a44" }} className="pl-2">
            <div className="d-flex align-items-center view-card-background pb-3">
              <img src={RenameFolderIcon} alt="rename" className="mr-2" />
              <p className="m-0" onClick={handleRenameFileData}>
                Rename File
              </p>
            </div>
            {isFileAndFolderDelete && (
              <div className="d-flex align-items-center view-card-background mt-1 pb-3">
                <img src={deleteIcon} alt="delete" className="mr-2" />
                <p
                  className="m-0"
                  onClick={() => handleDeleteFileAndFolder?.(fileData)}
                >
                  Delete File
                </p>
              </div>
            )}
            {isHideAndShowFileFolderPresent&&isParrentHide&&fileData?.parent_id!==0?null:isHideAndShowFileFolderPresent && (
             <div className="d-flex align-items-center view-card-background pb-2">
              <img src={documentFile.is_hidden ? grayViewIcon : HideIcon} alt="rename" className="mr-2" />
              <p className="m-0" onClick={() => 
                {
                  if (documentFile.is_hidden) {
                    handleUnHideFileFolder?.(fileData);
                  } else {

                    handleHideFileFolder?.(fileData);
                  }
                }
                }>
                               {documentFile.is_hidden ? "Show File" : "Hide File"}
              </p>
            </div>
            )}
          </div>
        </div>
      );
    };
    const renderDownloadInvoiceToolTip = (props: any) => {
      return (
        <Tooltip id="button-view-open-item" {...props}>
          {documentFile?.file_name}
        </Tooltip>
      );
    };
    const renderData = (data: ImageDataType) => {
      getImageDetails && getImageDetails(data);
    };

    const handleDownload = async (fileUrl: string, fileName: string) => {
      const response = await fetch(`${blobBaseUrl}${fileUrl}?${blobToken}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const downloadFileUrl = document.createElement("a");
      downloadFileUrl.href = url;
      downloadFileUrl.download = fileName || "downloaded_file"; 
      document.body.appendChild(downloadFileUrl);
      downloadFileUrl.click();
      downloadFileUrl.remove();  
  
      window.URL.revokeObjectURL(url);  
  
  };
    const settingFileData = (
      finalFileName: string,
      fileUrl: string,
      fileType: string
    ): void => {
      setMultipleFileData((prev: any) => [
        ...prev,
        { file_name: finalFileName, file_url: fileUrl, file_type: fileType },
      ]);
    };

    const settingIsChecked = (fileUrl: string) => {
      let newData = JSON.parse(JSON.stringify(filesData));

      newData?.map((item: any) => {
        if (fileUrl === item.file_url && item.hasOwnProperty("isChecked")) {
          item.isChecked = !item.isChecked;
        } else if (fileUrl === item.file_url) {
          item.isChecked = true;
        }
      });
      setFilesData([...newData]);
    };

    const previewData = () => {
      return (
        <div
          onClick={() => {
            renderData({
              imageUrl: blobBaseUrl + documentFile["file_url"] + "?" + blobToken,
              downloadImage: documentFile["file_url"],
              fileType,
              finalFileName,
              updateBy: documentFile?.updated_by_name,
              updatedAt: moment
                .utc(documentFile?.created_at)
                .local()
                .format("DD-MM-YYYY, h:mm a"),
            });
          }}
        >
          {type && (
            <div
              style={{ position: "absolute", top: "10px", right: "10px" }}
              onClick={() => {
                !documentFile.isChecked
                  ? settingFileData(
                      finalFileName,
                      documentFile["file_url"],
                      fileType
                    )
                  : removingFileData && removingFileData(documentFile["file_url"]);
                settingIsChecked(documentFile["file_url"]);
              }}
            >
              {documentFile.isChecked ? (
                <img src={checked} alt="" />
              ) : (
                <img src={unChecked} alt="" />
              )}
            </div>
          )}

          {showDeleteIcon && (
            <div className="delete-file-icon">
              <i className="fas fa-minus-circle"></i>
            </div>
          )}

          {fileType?.toLowerCase() === "image/png" ||
          fileType?.toLowerCase() === "image/jpeg" ||
          fileType?.toLowerCase() === "image/jpg" ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#e1e1e3",
                borderRadius: "0px",
                overflow: "hidden",
                padding: "17px 25px",
              }}
            >
              <img
                src={
                  fileType?.toLowerCase() === "image/png" ||
                  fileType?.toLowerCase() === "image/jpeg" ||
                  fileType?.toLowerCase() === "image/jpg"
                    ? blobBaseUrl + documentFile["file_url"] + "?" + blobToken
                    : returnIcon(fileType)
                }
                alt={`file_manager_${finalFileName}`}
                width="100%"
                height="186px"
                loading="lazy"
              />
            </div>
          ) : (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#e1e1e3",
                borderRadius: "0px",
                padding: "32px",
                overflow: "hidden",
              }}
            >
              <img
                src={returnIcon(fileType)}
                alt={`file_manager_${finalFileName}`}
                style={{ width: "156", height: "156px" }}
                loading="lazy"
              />
            </div>
          )}

          <div
            className="d-flex flex-column align-items-start justify-content-center"
            style={{
              backgroundColor: "white",
              position: "relative",
              borderRadius: "6px",
            }}
          >
            <div
              className="file-name mt-1"
              style={{
                width: "fit-content",
                wordBreak: "break-word",
                backgroundColor: "white",
                borderRadius: "6px",
                fontWeight: "500",
              }}
            >
              {finalFileName}
            </div>
          </div>
       
        </div>
      );
    };

    const downloadFilesData = () => {
      return (
        <>
          {showDeleteIcon && (
            <div className="delete-file-icon">
              <i className="fas fa-minus-circle"></i>
            </div>
          )}
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: "#e1e1e3",
              borderRadius: "0px",
              padding: "32px",
              overflow: "hidden",
            }}
          >
            <img
              src={returnIcon(fileType)}
              alt={`file_manager_${finalFileName}`}
              style={{ width: "156px", height: "156px" }}
              width="50"
            />
          </div>
          <div
            className="d-flex flex-column align-items-start justify-content-center"
            style={{ backgroundColor: "white", borderRadius: "6px" }}
          >
            <div
              className="file-name mt-1"
              style={{
                width: "fit-content",
                wordBreak: "break-word",
                backgroundColor: "white",
                borderRadius: "6px",
                fontWeight: "500",
              }}
            >
              {finalFileName}
            </div>
          
          </div>
         
        </>
      );
    };

    const downloadFiles = () => {
      return !!type ? (
        <div>
          {type && (
            <div
              style={{ position: "absolute", top: "10px", right: "10px" }}
              onClick={() => {
                !documentFile.isChecked
                  ? settingFileData(
                      finalFileName,
                      documentFile["file_url"],
                      fileType
                    )
                  : removingFileData && removingFileData(documentFile["file_url"]);
                settingIsChecked(documentFile["file_url"]);
              }}
            >
              {documentFile.isChecked ? (
                <img src={checked} alt="" />
              ) : (
                <img src={unChecked} alt="" />
              )}
            </div>
          )}
          {downloadFilesData()}
        </div>
      ) : (
        <a
          onClick={() => handleDownload(documentFile?.file_url, documentFile?.file_name)}

          style={{ textDecoration: "none" }}
        >
          {downloadFilesData()}
        </a>
      );
    };
    return (
      <div style={type ? { width: "215px" } : {}}  className="file-container">
        {viewMoreFileId === documentFile.id && showViewMoreFiles && (
          <ViewMoreBox
            handleToggleViewMoreFiles={handleToggleViewMoreFiles}
            fileData={documentFile}
            handleSetFileRenameModalData={handleSetFileRenameModalData}
            handleHideFileFolder={handleHideFileFolder}
            handleUnHideFileFolder={handleUnHideFileFolder}
            isParrentHide={isParrentHide}
            isHideAndShowFileFolderPresent={isHideAndShowFileFolderPresent}

          />
        )}
         {/* eslint-disable-next-line */}
        <a
          href={blobBaseUrl + documentFile["file_url"] + "?" + blobToken}
          style={{ textDecoration: "none" }}
        ></a>
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 250 }}
          overlay={renderDownloadInvoiceToolTip}
        >
          <div>
            {!!type && (
              <div
                onClick={() =>
                  handleUploadInvoiceFile &&
                  handleUploadInvoiceFile(
                    finalFileName,
                    documentFile["file_url"],
                    fileType
                  )
                }
              ></div>
            )}
            {fileType.toLowerCase() === "image/png" ||
            fileType.toLowerCase() === "image/jpeg" ||
            fileType.toLowerCase() === "image/jpg" ||
            fileType.toLowerCase() === "application/msword" ||
            fileType.toLowerCase() === "application/vnd.ms-excel" ||
            fileType.toLowerCase() ===
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            fileType.toLowerCase() ===
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
            fileType.toLowerCase() ===
              "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
            fileType.toLowerCase() === "application/vnd.ms-powerpoint" ||
            fileType.toLowerCase() === "application/pdf"
              ? previewData()
              : downloadFiles()}
          </div>
        </OverlayTrigger>
        {isRenameFilePresent && (
          <div
            className="rename-file-icon"
            onClick={(e: any) => handleViewMoreClick(e, documentFile.id)}
          >
            <i
              style={{ fontSize: "25px", color: "#5f697b" }}
              className="las la-ellipsis-v"
            ></i>
          </div>
        )}
      </div>
    );
  }
);

export default Files;